const Types = {
  // list
  GET_COUNTIRES_SUCCESS: "GET_COUNTIRES_SUCCESS",
  //loading
  COUNTIRES_LOADING: "COUNTIRES_LOADING",
  GET_SCROLL_COUNTRIES_SUCCESS: "GET_SCROLL_COUNTRIES_SUCCESS"
};

export default Types;
